
import React from 'react';
import { Button } from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export const CruiseExploreSection: React.FC = () => {
  const navigate = useNavigate();

  const handleBookNow = () => {
    navigate(`/contact?subject=${encodeURIComponent('Enquiry about Cruises')}`);
  };

  return (
    <section
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('/images/cruises-explore.jpg')`
      }}
    >
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          <span className="text-emerald-400">Explore Our Cruises</span>
        </h2>
        <p className="text-lg text-white mb-8 leading-relaxed max-w-3xl mx-auto">
          Ready to set sail on your next adventure? Book your cruise with us today and explore breathtaking destinations while enjoying world-class amenities. Whether you're looking for relaxation or adventure, we have the perfect cruise waiting for you. Start your journey now and create unforgettable memories on the open seas!
        </p>
        <Button size="lg" onClick={handleBookNow} className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4">
          <i className="ri-ship-line w-5 h-5 flex items-center justify-center mr-2"></i>
          Book Now
        </Button>
      </div>
    </section>
  );
};
